export const minimumDefaults = {
  catering: 1500,
  dessert: 1000,
}

// Flat per-person prices. Dessert and drink are cheaper as add-ons to a bigger order
const ENTREE_PRICE = 20
const DESSERT_PRICE = 14
const DESSERT_ADDON_PRICE = 5
const DRINK_PRICE = 11
const DRINK_ADDON_PRICE = 4

// Floor on a catering tag page when no entree is selected
const TAG_PAGE_MINIMUM = 400

const hasFood = (args, food) =>
  !!args.foods?.some(key => key.toLowerCase() === food)

/**
 * Resolves the one minimum that applies to this page and selection.
 * args.catering is the page's own minimum: the cuisine config on a cuisine
 * page, otherwise the city catering_minimums row (default 1500).
 * Per-city dessert_min (args.dessert) is intentionally not used.
 *  - Entree selected: args.catering, on every page type
 *  - Catering tag page, no entree: 400
 *  - Cuisine page, no entree: args.catering
 *  - Any other page, no entree: half of args.catering
 * @param {*} args
 * @returns
 */
const calculateMinimums = args => {
  if (hasFood(args, 'main')) {
    return args.catering
  }

  if (args.cateringTagPage) {
    return TAG_PAGE_MINIMUM
  }

  if (args.cuisinePage) {
    return args.catering
  }

  return args.catering / 2
}

/**
 * Generates the per-person price of each selected food (0 when not selected)
 * @param {*} args
 * @returns
 */
const calculatePrices = args => {
  const main = hasFood(args, 'main')
  const dessert = hasFood(args, 'dessert')
  const drink = hasFood(args, 'drink')

  return {
    // Cuisine pages pass their own entree rate, everything else gets the default
    main: main ? args.pricePerPerson || ENTREE_PRICE : 0,
    dessert: dessert ? (main ? DESSERT_ADDON_PRICE : DESSERT_PRICE) : 0,
    drink: drink ? (main || dessert ? DRINK_ADDON_PRICE : DRINK_PRICE) : 0,
  }
}

export const calculate = args => {
  const eaters = args.eaters || 0

  if (eaters < 1) {
    return 0
  }

  const prices = calculatePrices(args)
  const per_person = prices.main + prices.dessert + prices.drink

  // Nothing selected
  if (!per_person) {
    return 0
  }

  // Round up to a whole dollar so quotes never display cents
  return Math.ceil(Math.max(per_person * eaters, calculateMinimums(args)))
}

export function getMiles(i) {
  return Math.ceil(i * 0.000621371192)
}

export function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
